<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      {{titolo}}
    </div>
  </mat-card-title>
  <!--<mat-card-content style="width:720px!important">-->
  <mat-card-content>
    <form [formGroup]='frmInserimento' class='inserimento-form'>
      <div class="container">
        <div class="row">
          <label>Sei sicuro di voler verificare l'utente?</label>

          <div class="col-md-4">
            <div class="mat-form-field">
              <mat-checkbox id="isVerificato" formControlName="isVerificato">
                Verificato
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div mat-dialog-actions>
      <button mat-raised-button color="primary"
              (click)="btnAnnulla()">
        Annulla
      </button>
      <button mat-raised-button color="primary"
              [disabled]="!frmInserimento.valid"
              (click)="btnSalva()">
        Salva
      </button>
    </div>
  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>
